import React from "react";
import { Navigate, useParams } from "react-router-dom";
import ResourceManager from "../components/ResourceManager";
import { resourceConfigs } from "../config/resources";

export default function ResourcePage({ resourceKey: propResourceKey }: { resourceKey?: string }) {
  const params = useParams();
  const resourceKey = propResourceKey || params.resourceKey;

  if (!resourceKey || !resourceConfigs[resourceKey]) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <ResourceManager config={resourceConfigs[resourceKey]} />;
}
